import { useCallback, useEffect, useState } from 'react';

const useRouletteHubState = ({
  handleGoToRoulette,
  handleGoToCompatibles,
  handleGoToOpuestos,
}) => {
  const [showRouletteHub, setShowRouletteHub] = useState(false);

  const closeRouletteHub = useCallback(() => {
    setShowRouletteHub(false);
  }, []);

  const goZodiacal = useCallback(() => {
    setShowRouletteHub(false);
    handleGoToRoulette();
  }, [handleGoToRoulette]);

  const goCompatibles = useCallback(() => {
    setShowRouletteHub(false);
    handleGoToCompatibles();
  }, [handleGoToCompatibles]);

  const goOpuestos = useCallback(() => {
    setShowRouletteHub(false);
    handleGoToOpuestos();
  }, [handleGoToOpuestos]);

  useEffect(() => {
    if (!showRouletteHub) return;

    const onKey = (e) => {
      if (e.key === 'Escape') closeRouletteHub();
    };

    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [showRouletteHub, closeRouletteHub]);

  useEffect(() => {
    if (!showRouletteHub) return;

    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';

    return () => {
      document.body.style.overflow = prev;
    };
  }, [showRouletteHub]);

  return {
    showRouletteHub,
    closeRouletteHub,
    goZodiacal,
    goCompatibles,
    goOpuestos,
  };
};

export default useRouletteHubState;
